/**
 * MainHeader React component
 * 
 * @author    Jens Gruschel, Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


// react
import React from 'react';
import {connect} from "react-redux";

// material UI
import {fade} from '@material-ui/core/styles/colorManipulator';
import {withStyles} from '@material-ui/core/styles';
import {AppBar, Toolbar, IconButton, Input, Tooltip} from '@material-ui/core';

// icons
import SearchIcon from '@material-ui/icons/Search';
import AssessmentIcon from '@material-ui/icons/Assessment';
import AccountCircle from '@material-ui/icons/AccountCircle';
// import NotificationsIcon from '@material-ui/icons/Notifications';
import MoreIcon from '@material-ui/icons/MoreVert';
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate';
import MovieCreationIcon from '@material-ui/icons/MovieCreation';

// application
import logo from "../../musos_logo.png";
import logoPulsar from "../../pulsar-light-transparent-textonly.png";
import AppMenuIcon from "./AppMenuIcon";
import {createNewMediaItem} from "../../operations/editing";
import {searchPhrase, updateSearchInput} from "../../operations/listing";
import {openPage} from "../../operations/view";
import {STORYTELLING_PAGE} from "../../redux/view/consts";


const styles = theme => ({
    root: {
        width: '100%',
    },
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing.unit * 2,
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit * 3,
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 200,
        },
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    logo: {
        /*animation: App-logo-spin infinite 20s linear;*/
        width: 87,
        float: "left",
        marginLeft: 54,
        marginRight: 51
    },
    logoPulsar: {
        /*animation: App-logo-spin infinite 20s linear;*/
        width: 150,
        float: "left",
        marginLeft: 22,
        marginRight: 29
    }
});

/**
 * MainHeader is the main header of the application showing the logo, a search bar etc.
 *
 * @author Jens Gruschel
 */
class MainHeader extends React.Component {

    handleSearchKeyDown = event => {

        if (event.keyCode === 13) {
            //if (this.props.searchInput != "") {
                this.props.searchPhrase(this.props.searchInput);
            //}
        }
    }

    render() {

        const {classes} = this.props;

        return (
            <header className={classes.root} style={{position: 'sticky', top: 0, zIndex: 100}}>
                <AppBar position="static">
                    <Toolbar>
                        {/*<IconButton className={classes.menuButton} color="inherit" aria-label="Open drawer">
                            <MenuIcon/>
                        </IconButton>*/}
                        <img src={this.props.theme === "pulsar" ? logoPulsar : logo}
                             className={this.props.theme === "pulsar" ? classes.logoPulsar : classes.logo} alt="logo"/>
                        <div className={classes.search}>
                            <div className={classes.searchIcon}>
                                <SearchIcon/>
                            </div>
                            <Input
                                id={"searchInput"}
                                value={this.props.searchInput}
                                placeholder="Suchen…"
                                disableUnderline
                                classes={{
                                    root: classes.inputRoot,
                                    input: classes.inputInput,
                                }}
                                onChange={event => this.props.updateSearchInput(event.target.value)}
                                onKeyDown={this.handleSearchKeyDown}
                            />
                        </div>
                        <Tooltip title="Medienelement anlegen">
                            <IconButton color="inherit"
                                    onClick={event => {this.props.createNewMediaItem()}}
                                >
                                    <AddPhotoAlternateIcon/>
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Storytelling">
                            <IconButton color="inherit"
                                    onClick={() => this.props.openPage(STORYTELLING_PAGE)}
                                >
                                    <MovieCreationIcon/>
                            </IconButton>
                        </Tooltip>
                        <div className={classes.grow}/>
                        <div className={classes.sectionDesktop}>
                            {/*<IconButton color="inherit">
                                <Badge className={classes.margin} badgeContent={4} color="error">
                                    <MailIcon/>
                                </Badge>
                            </IconButton>*/}
                            {/*<IconButton color="inherit">
                                <Badge className={classes.margin} badgeContent={3} color="error">
                                    <NotificationsIcon/>
                                </Badge>
                            </IconButton>*/}
                            <AppMenuIcon variant="dashboard" icon={<AssessmentIcon/>} />
                            <AppMenuIcon variant="profile" icon={<AccountCircle/>} />
                        </div>
                        <div className={classes.sectionMobile}>
                            <AppMenuIcon variant="mobile" icon={<MoreIcon/>} />
                        </div>
                    </Toolbar>
                </AppBar>
            </header>
        );
    }
}

const mapStateToProps = state => {

    return {
        searchInput: state.listing.searchInput,
        theme: state.configuration.active.theme
    }
};

export default connect(mapStateToProps, {
    createNewMediaItem,
    updateSearchInput,
    searchPhrase,
    openPage,
})(withStyles(styles)(MainHeader));